"use strict";Object.defineProperty(exports,Symbol.toStringTag,{value:"Module"});var e=(t=>(t.Compact="compact",t.Multiline="multiline",t))(e||{});exports.SnackbarVariant=e;
